<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Amplify`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5594 17.8447C14.9194 19.1657 12.8342 19.9564 10.5643 19.9564C5.28207 19.9564 1 15.6744 1 10.3922C1 5.10995 5.28207 0.827881 10.5643 0.827881C15.8465 0.827881 20.1285 5.10995 20.1285 10.3922C20.1285 12.7487 19.2762 14.9063 17.8631 16.5733C17.8928 16.5964 17.9214 16.6216 17.9488 16.6488L21.511 20.1993C21.8706 20.5576 21.8715 21.1396 21.5132 21.4992C21.1548 21.8587 20.5728 21.8597 20.2133 21.5013L16.651 17.9509C16.6173 17.9173 16.5868 17.8818 16.5594 17.8447ZM18.0309 10.3937C18.0309 14.5188 14.6866 17.954 10.5616 17.954C6.43656 17.954 3.09235 14.6099 3.09235 10.4848C3.09235 6.35961 6.43665 2.92443 10.5617 2.92443C14.6867 2.92443 18.0309 6.26852 18.0309 10.3937ZM10.5643 7.20414C10.0612 7.20414 9.65341 7.61196 9.65341 8.11502V9.93668H7.83171C7.32865 9.93668 6.92083 10.3445 6.92083 10.8476C6.92083 11.3506 7.32865 11.7584 7.83171 11.7584H9.65341V13.5803C9.65341 14.0834 10.0612 14.4912 10.5643 14.4912C11.0674 14.4912 11.4752 14.0834 11.4752 13.5803V11.7584H13.297C13.8001 11.7584 14.2079 11.3506 14.2079 10.8476C14.2079 10.3445 13.8001 9.93668 13.297 9.93668H11.4752V8.11502C11.4752 7.61196 11.0674 7.20414 10.5643 7.20414Z"/></svg>
</template>
<script>

export default {
  name: 'IconAmplify',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
